export default __webpack_public_path__ + "static/media/item5.f612db6b.jpg";